import { IHeaderParams } from "ag-grid-community";
import { Box, Flex, Icon } from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface CollapsibleSheetHeaderProps extends IHeaderParams {
  items?: string[];
  isCollapsed: boolean;
  onToggle: (colId: string) => void;
}

// SheetHeader 의 세 줄 라벨에 접기(−)/펼치기(+) 버튼을 붙인 헤더.
// 접히면 라벨은 숨기고 + 버튼만 남겨서 좁은 폭에서도 다시 펼칠 수 있게 한다.
export default function CollapsibleSheetHeader({
  items = [],
  isCollapsed,
  onToggle,
  column,
}: CollapsibleSheetHeaderProps) {
  const { t, tTitle } = useI18nHelper();
  const labels = items.filter((item) => item).map((item) => tTitle(item));

  const toggleButton = (
    <Box
      as={"button"}
      type={"button"}
      aria-label={t(isCollapsed ? "expand_column" : "collapse_column")}
      title={
        isCollapsed && labels.length > 0
          ? `${t("expand_column")} (${labels.join(" / ")})`
          : t(isCollapsed ? "expand_column" : "collapse_column")
      }
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      flexShrink={0}
      boxSize={"16px"}
      borderRadius={"2px"}
      color={"#8F8F8C"}
      _hover={{ color: "#1272EF", backgroundColor: "#EDF4FE" }}
      onClick={() => onToggle(column.getColId())}
    >
      <Icon
        as={SVG}
        src={isCollapsed ? "/icons-v1_1/plus.svg" : "/icons-v1_1/minus.svg"}
        boxSize={"14px"}
      />
    </Box>
  );

  if (isCollapsed) {
    // 브랜드/SKU 칼럼은 autoHeaderHeight 로 헤더 전체 높이를 정한다.
    // 접혀도 줄 수만큼 빈 줄을 남겨 두어야 다른 칼럼의 세 줄 헤더가 잘리지 않는다.
    return (
      <Flex flexDirection={"column"} gap={"6px"} width={"100%"}>
        <Flex justifyContent={"center"}>{toggleButton}</Flex>
        {items.slice(1).map((_, index) => (
          <Box key={index} visibility={"hidden"}>
            &nbsp;
          </Box>
        ))}
      </Flex>
    );
  }

  return (
    <Flex width={"100%"} alignItems={"start"}>
      {/* 옆 SheetHeader 들은 globals.css 가 루트 gap 을 6px 로 덮어써서 6px 로 맞춘다. */}
      <Flex flexDirection={"column"} gap={"6px"} flex={1} minWidth={0}>
        {/* 빈 라벨("")도 한 줄 높이를 차지해야 세 줄이 채워져 − 버튼이 다른 칼럼처럼 맨 윗줄에 온다. */}
        {items.map((item, index) => {
          return <Box key={index}>{item ? tTitle(item) : " "}</Box>;
        })}
      </Flex>
      {toggleButton}
    </Flex>
  );
}
